export type CodeStepStatus =
  | { readonly kind: 'entering' }
  | { readonly kind: 'verifying'; readonly message?: string }
  | { readonly kind: 'refused'; readonly message: string; readonly detail?: string | null }
  | { readonly kind: 'expired' }
  | { readonly kind: 'blocked'; readonly message: string };

export type CodeStepHalt = Extract<CodeStepStatus, { kind: 'expired' | 'blocked' }>;

export type CodeStepLive = Exclude<CodeStepStatus, CodeStepHalt>;

export interface CodeEntryState {
  readonly verifying: boolean;
  readonly verifyingText?: string;
  readonly errorText: string | null;
  readonly detailText: string | null;
}

export const isHalted = (status: CodeStepStatus): status is CodeStepHalt => status.kind === 'expired' || status.kind === 'blocked';

export const entryStateOf = (status: CodeStepLive): CodeEntryState => {
  switch (status.kind) {
    case 'entering':
      return { verifying: false, errorText: null, detailText: null };
    case 'verifying':
      return { verifying: true, verifyingText: status.message, errorText: null, detailText: null };
    case 'refused':
      return { verifying: false, errorText: status.message, detailText: status.detail ?? null };
  }
};
